import { createFileRoute } from '@tanstack/react-router'
import { CapabilityPage } from '@/components/engineering/EngineeringPages'
import { localizedPageHead } from '@/lib/seo-head'

export const Route = createFileRoute('/{-$locale}/data-analytics')({
  head: ({ params }) => localizedPageHead('dataAnalytics', params.locale),
  component: () => <CapabilityPage kind="dataAnalytics" />,
})
